export default {
  title: 'Account Page',
  header: 'Account'
}
